<!-- toast-container.component.html -->
<div class="pointer-events-none fixed inset-0 z-[9999]">
  <div class="relative h-full">
    @for (toast of toasts(); track toast.toastRef) {
      <liv-toast
        [index]="toast.stackIndex ?? 0"
        [id]="toast.id"
        [instanceId]="toast.instanceId"
        [offset]="toast.offset"
        [message]="toast.message"
        [variant]="toast.variant"
        [position]="toast.position"
        [duration]="toast.duration"
        [dismissible]="toast.dismissible"
        [autoClose]="toast.autoClose"
        [showIcon]="toast.showIcon"
        [className]="toast.className"
        [ref]="toast.toastRef"
        (closed)="onToastClosedHandler($event)"
      />
    }
  </div>
</div>
